import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from 'react-awesome-modal';
import { List } from 'react-virtualized';
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {css} from "@emotion/core";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilterSingleSelect.jsx';
import "./refund_module.css";
import LineChart from '../amcharts/RefundLineChart';
import ClusteredBarChart from '../amcharts/ClusteredBarChart';
import DatePicker from "react-datepicker";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', '2020-02-01','1');
var DailySettTable='';
var y_axis = ["Transaction Values","Transaction Counts"]
var x_axis = ["Transaction Values"]
var y_axis1 = ["Success","Failed"]
var chartData = [
  {
    "Transaction Date": "2024-03-07",
    "Transaction Values": 4100000.42,
    "Transaction Counts": 245

  },
  {
    "Transaction Date": "2024-03-08",
    "Transaction Values": 2245477.11,
    "Transaction Counts": 100
  },
  {
    "Transaction Date": "2024-03-09",
    "Transaction Values": 1777358.11,
    "Transaction Counts": 10
  },
  {
    "Transaction Date": "2024-03-10",
    "Transaction Values": 1757141.02,
    "Transaction Counts": 80
  },
  {
    "Transaction Date": "2024-03-11",
    "Transaction Values": 2861512.62,
    "Transaction Counts": 5
  },
  {
    "Transaction Date": "2024-03-12",
    "Transaction Values": 2720790.15,
    "Transaction Counts": 234
  },
  {
    "Transaction Date": "2024-03-13",
    "Transaction Values": 1759285.96,
    "Transaction Counts": 89
  },
  {
    "Transaction Date": "2024-03-14",
    "Transaction Values": 3497217.31,
    "Transaction Counts": 77
  },
  {
    "Transaction Date": "2024-03-15",
    "Transaction Values": 1976022.96,
    "Transaction Counts": 45
  },
  {
    "Transaction Date": "2024-03-16",
    "Transaction Values": 705547.58,
    "Transaction Counts": 156
  }
]

var chartData1 = [

  {
    "Transaction Date": "8",
    "Success": 1,
    "Fail": 0
  },
  {
    "Transaction Date": "9",
    "Success": 1,
    "Fail": 0
  },
  {
    "Transaction Date": "10",
    "Success": 1,
    "Fail": 1
  },
  {
    "Transaction Date": "11",
    "Success": 0,
    "Fail": 1
  }
]
class RefundModuleDashboard extends Component{
    constructor(props) {
        super(props);
        this.state ={
            _notificationSystem: null,
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            tableLoading: true,
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            isChange: false,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            industryCategoryList:[],
            industryCategoryValue: null,
            industryCategoryIds:'',
            fetch_data:false,
            chartHeight: "280px",
            refund_transaction_count: '',
            refund_transaction_value: '',
            kpi2_loading:false,
            success_failed_list:[],
            is_chart2_loading:false,
            is_chart1_loading:false,
            transaction_value:'',
            transaction_count:'',
            is_chart1_loading:false,
            count_volumn_list:[]
        }
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        //isReportAccess(AllAccessPermissions, 'daily_settlement');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }

    componentDidUpdate() {
    }
    componentDidMount() {
        this._get_txn_kpi(this.state.object_type,this.state.object_code,'');
        this._get_refund_kpi(this.state.object_type,this.state.object_code,'');
        //this._get_count_volumn_chart(this.state.object_type,this.state.object_code,'');
        this._get_success_fail_chart(this.state.object_type,this.state.object_code,'');
        this._get_success_count_volumn_chart(this.state.object_type,this.state.object_code,'');
        //user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'daily_settlement_report','sparcs')
    }
    applyChanges(object_type, object_code, event){
        this._get_txn_kpi(this.state.object_type,this.state.object_code,'');
        this._get_refund_kpi(this.state.object_type,this.state.object_code,'');
        this._get_success_fail_chart(this.state.object_type,this.state.object_code,'');
        this._get_success_count_volumn_chart(this.state.object_type,this.state.object_code,'');
    }
    _get_success_fail_chart(object_type, object_code, event) {
        this.setState({
            is_chart2_loading:false
        })
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids:  stores,
            yestSend: this.state.yestSend,
            todSend: this.state.yestSend
//             yestSend: '2022-03-03',
//             todSend: '2022-03-03'
        };
        axios.post(config.get('API_URL') + '/RefundModule/success_fail/', postData, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log("kk",response.data.data);
            this.setState({
                is_chart2_loading:true,
                success_failed_list:response.data.data
            })
        });
    }
    _get_txn_kpi(object_type, object_code, event) {
        this.setState({
            kpi1_loading:false
        })
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids:  stores,
            yestSend: this.state.yestSend,
            todSend: this.state.yestSend
        };
        axios.post(config.get('API_URL') + '/RefundModule/txn_kpi/', postData, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response);
            this.setState({
                kpi1_loading:true,
                transaction_count:response.data.data[0]["Transaction Counts"],
                transaction_value:response.data.data[0]["Transaction Values"]>0?response.data.data[0]["Transaction Values"]:0
            })
        });
    }

    _get_refund_kpi(object_type, object_code, event) {
        this.setState({
            kpi2_loading:false
        })
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids:  stores,
            yestSend: this.state.yestSend,
            todSend: this.state.yestSend
        };
        axios.post(config.get('API_URL') + '/RefundModule/refund_kpi/', postData, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data.data[0]);
            this.setState({
                kpi2_loading:true,
                refund_transaction_count:response.data.data[0].refund_transaction_count,
                refund_transaction_value:response.data.data[0].refund_transaction_value>0?response.data.data[0].refund_transaction_value:0
            })
        });
    }

    _get_success_count_volumn_chart(object_type, object_code, event) {
        this.setState({
            is_chart1_loading:false
        })
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids:  stores,
            yestSend: this.state.yestSend,
            todSend: this.state.yestSend
//             yestSend: '2022-03-03',
//             todSend: '2022-03-03'
        };
        axios.post(config.get('API_URL') + '/RefundModule/count_volumn/', postData, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log("kk",response.data.data);
            this.setState({
                is_chart1_loading:true,
                count_volumn_list:response.data.data
            })
        });
    }
    reset_all(e){
         this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
//             this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
//             this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');

        }

        this.refs.cityFilter.resetCityFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.industryCategoryFilter.resetIndustryCategoryFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            campaignCodeValue:[],
            campaignCodeIDs:'',
            industryCategoryIds:'',
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
//         this.refs.reloadIssuer._txn_issuer_bank(yestSend, todSend);

    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
//         this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
//         this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
//         this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }

    handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    handleFromChange = date => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        this.setState({
            yestSend: formattedDate
        });
    };

     render() { console.log(this.state.success_failed_list);
     console.log(this.state.count_volumn_list);

        return(
           
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Dashboard</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    {/*<div className="row">*/}
                                    <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                        <div><label> Date Filter: </label></div>
                                        <DatePicker
                                                            dateFormat="yyyy-MM-dd"
                                                            selected={Date.parse(this.state.yestSend)}
                                                            onChange={this.handleFromChange}
                                                            maxDate={new Date()}

                                                        />
{/*                                         <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow} */}
{/*                                                 start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/> */}
                                        </div>
{/*                                         {this.state.object_type ==='Innoviti'? */}
{/*                                             <div className="col-md-2 filter-bottom5 padd-5"> */}
{/*                                                 <label>Merchants</label> */}
{/*                                                 <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> : null} */}
{/*                                             {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'? */}
{/*                                                 <div className="col-md-2 filter-bottom5 padd-5"> */}
{/*                                                     <label> Chain </label> */}
{/*                                                     <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/> */}
{/*                                                     <div className="clearfix"></div> */}
{/*                                                 </div>: null } */}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain' || this.state.object_type ==='Store'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                    <div className="col-md-4">

                                        <button type="button" className="primary apply-filter1" role="button"  onClick={this.applyChanges.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>

                                    </div>

                                    {/*</div>*/}
                                    <div className="clearfix"></div>

                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                         {this.state.kpi1_loading===true?
                                        <div class="col-md-3">
                                        <div className="card-stats-kpi1">
                                            <div class="col-md-2 padd-5"><div class="icon-refund-kpi"><i class="pe-7s-wallet"></i></div></div>
                                            <div class="col-md-5 padd-5"><div class="kip-text"><p>Successful</p> <p>Transactions</p> <p>Count</p></div></div>
                                            <div class="col-md-5 padd-10"><div class="kpi-numbers">{this.state.transaction_count}</div></div>
                                            <div className="clearfix"></div>
                                        </div>
                                        </div>:
                                        <div className="col-md-3"> <div className="linear-background1"></div></div>
                                        }
                                        {this.state.kpi1_loading===true?
                                        <div class="col-md-3">
                                        <div className="card-stats-kpi2">
                                            <div class="col-md-2 padd-5"><div class="icon-refund-kpi"><i class="pe-7s-cash"></i></div></div>
                                            <div class="col-md-5 padd-5"><div class="kip-text"><p>Successful</p> <p>Transactions</p> <p>Value</p></div></div>
                                            <div class="col-md-5 padd-10"><div class="kpi-numbers">&#8377;{" "}{this.state.transaction_value}</div></div>
                                            <div className="clearfix"></div>
                                        </div>
                                        </div>
                                        :
                                        <div className="col-md-3"> <div className="linear-background1"></div></div>
                                        }
                                        {this.state.kpi2_loading===true?
                                        <div class="col-md-3">
                                        <div className="card-stats-kpi3">
                                            <div class="col-md-2 padd-5"><div class="icon-refund-kpi"><i class="pe-7s-wallet"></i></div></div>
                                            <div class="col-md-5 padd-5"><div class="kip-text"><p>Refund</p> <p>Transactions</p> <p>Count</p></div></div>
                                            <div class="col-md-5 padd-10"><div class="kpi-numbers">{this.state.refund_transaction_count}</div></div>
                                            <div className="clearfix"></div>
                                        </div>
                                        </div>:
                                        <div className="col-md-3"> <div className="linear-background1"></div></div>
                                        }
                                        {this.state.kpi2_loading===true?
                                        <div class="col-md-3">
                                        <div className="card-stats-kpi4">
                                            <div class="col-md-2 padd-5"><div class="icon-refund-kpi"><i class="pe-7s-cash"></i></div></div>
                                            <div class="col-md-5 padd-5"><div class="kip-text"><p>Refund</p> <p>Transactions</p> <p>Value</p></div></div>
                                            <div class="col-md-5 padd-10"><div class="kpi-numbers">&#8377;{" "}{this.state.refund_transaction_value}</div></div>
                                            <div className="clearfix"></div>
                                        </div>
                                        </div>
                                        :
                                        <div className="col-md-3"> <div className="linear-background1"></div></div>
                                        }
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="b-rf-d">
                                        <div class="col-md-6"><div class="bvp-shadow"><div class="rf-chart-title">Successful Transaction Count</div></div></div>
                                        <div class="col-md-6"><div class="bvp-shadow"><div class="rf-chart-title">Transaction Status</div></div></div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="rf-chart-container">
                                        {this.state.is_chart1_loading===true?
                                        <div className="col-md-6">
                                            <div className="card">
                                            <br/>
                                            {Array.isArray(this.state.count_volumn_list) && this.state.count_volumn_list.length>0?
                                                <LineChart data={this.state.count_volumn_list} x_axis="Transaction Time"
                                                y_axis={y_axis}
                                                chartHeight={this.state.chartHeight}
                                                name="Transaction Amount by Payment Type - Non EFT"
                                                />:<p className="no-data">No Data Found</p>}
                                            </div>
                                        </div>
                                        :<div className="col-md-6"><div className="linear-background-chart1"></div></div>}
                                        {this.state.is_chart2_loading===true?
                                        <div className="col-md-6">
                                            <div className="card">
                                            <br/>
                                            {Array.isArray(this.state.success_failed_list) && this.state.success_failed_list.length>0?
                                                <ClusteredBarChart data={this.state.success_failed_list} x_axis="Transaction Time" y_axis={y_axis1}
                                                chartHeight={this.state.chartHeight} name=""
                                                />:<p className="no-data">No Data Found</p>}
                                            </div>
                                        </div>
                                        :<div className="col-md-6"><div className="linear-background-chart1"></div></div>}
                                        <div className="clearfix"></div>
                                    </div>

                                    <div className="clearfix"></div>


                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                                              
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(RefundModuleDashboard)